import safeCreateAction from "../../../actions/safeCreateAction";
export const setGameInfo = safeCreateAction("SET_GAME_INFO", (gameId, provider, priority, expires, values) => ({ gameId, provider, priority, expires, values }));
